import BaseDecorator from "./BaseDecorator";
import ProductOrderFieldPickupPointOptionDecorator from "./ProductOrderFieldPickupPointOptionDecorator";

export default class ProductOrderFieldPickupPointValueDecorator extends BaseDecorator {
  transformData(data) {
    return super.transformData({
      ...data,
      pickup_point_option:
        data.pickup_point_option && new ProductOrderFieldPickupPointOptionDecorator(data.pickup_point_option),
    });
  }

  get name() {
    if (this.pickup_point_option.pickup_point_type === "custom") {
      return I18n.t("activerecord.attributes.product_order_field.custom_pickup_point_display_name", {
        custom_location_name: this.custom_location_name || "",
      });
    } else {
      return this.pickup_point_option.name;
    }
  }

  get price() {
    return this.pickup_point_option.price;
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductOrderFieldPickupPointValueDecorator.js